import { isDevMode } from '@angular/core';

import { readValueAtKeys } from '../schema-address';
import { SchemaRootResolver } from './schema-root';

/** `$context` — the one bag a host publishes with `provideSchemaContext`. A key it does not hold is silent. */
export const contextRoot: SchemaRootResolver = {
  resolve(address, scope) {
    const context = scope.context();

    if (!context) {
      reportMissingContext(address.text);

      return undefined;
    }

    return readValueAtKeys(context, address.keys);
  },
};

/** A key missing from the context may be an absent value; no context at all is a wiring bug. */
function reportMissingContext(text: string): void {
  if (isDevMode()) {
    console.warn(
      `Schema address "${text}" names "$context", but no SCHEMA_CONTEXT is reachable from this injector, so it ` +
        `resolves to nothing. Add provideSchemaContext(…) where this schema is rendered.`
    );
  }
}
